import { State } from "@/state";
import { useLayoutEffect } from "react";
import { PanelRightOpenIcon } from "lucide-react";

export const COMMAND_ID = "toggle-panel-visibility";

export type TogglePanelVisibilityContextType = Record<string, never>;

export function TogglePanelVisibilityCommand() {
  const registerCommandDefinition = State(
    (state) => state.registerCommandDefinition,
  );
  const unregisterCommandDefinition = State(
    (state) => state.unregisterCommandDefinition,
  );

  useLayoutEffect(() => {
    registerCommandDefinition({
      id: COMMAND_ID,
      title: "Toggle Panel",
      getTitle: () => {
        const st = State.getState();
        return st.isNodePanelOpen || st.isThreadPanelOpen
          ? "Hide Panel"
          : "Show Panel";
      },
      description: "Toggle the panel visibility",
      onClick: () => {
        const st = State.getState();
        const anyOpen = st.isNodePanelOpen || st.isThreadPanelOpen;
        if (anyOpen) {
          st.closeAllPanels();
        } else {
          st.openThreadPanel();
        }
        st.clearCommandStack();
      },
      ReactIcon: PanelRightOpenIcon,
      group: "Appearance",
    });

    return () => {
      unregisterCommandDefinition(COMMAND_ID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
